import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsUsersByLanguageQuery } from "../graphql/queries";
import type {
  AnalyticsUsersByLanguageQueryType,
  AnalyticsUsersByLanguageQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsUsersByLanguageQuery = (
  options?: QueryHookOptions<
    AnalyticsUsersByLanguageQueryType,
    AnalyticsUsersByLanguageQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsUsersByLanguageQueryType,
    AnalyticsUsersByLanguageQueryVariablesType
  >(AnalyticsUsersByLanguageQuery, options);
};
